export const PENDING_FRIEND_INVITE_KEY = "human-design.pending-friend-invite";

export function getPendingFriendInvite() {
  if (typeof window === "undefined") return "";
  return window.localStorage.getItem(PENDING_FRIEND_INVITE_KEY) || "";
}

export function rememberPendingFriendInvite(token: string) {
  if (typeof window === "undefined" || !token) return;
  window.localStorage.setItem(PENDING_FRIEND_INVITE_KEY, token);
}

export function clearPendingFriendInvite() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(PENDING_FRIEND_INVITE_KEY);
}

const PENDING_FRIEND_REQUEST_KEY = "human-design.pending-friend-request";

export function getPendingFriendRequest() {
  if (typeof window === "undefined") return "";
  const username = window.localStorage.getItem(PENDING_FRIEND_REQUEST_KEY) || "";
  return /^[a-z0-9_]{3,24}$/.test(username) ? username : "";
}

export function rememberPendingFriendRequest(username: string) {
  if (typeof window === "undefined" || !/^[a-z0-9_]{3,24}$/.test(username)) return;
  window.localStorage.setItem(PENDING_FRIEND_REQUEST_KEY, username);
}

export function clearPendingFriendRequest() {
  if (typeof window !== "undefined") window.localStorage.removeItem(PENDING_FRIEND_REQUEST_KEY);
}
